interface IBank {
  en_name: string;
  ar_name: string;
  code: string;
  swift_code: string;
}
interface IInvestorBankDetails {
  receiver_full_name: string;
  iban: string;
  bank: IBank;
}

class InvestorBankDetails implements IInvestorBankDetails {
  receiver_full_name: string;
  iban: string;
  bank: IBank;

  constructor(data: Partial<IInvestorBankDetails>) {
    this.receiver_full_name = data.receiver_full_name ?? '';
    this.iban = data.iban ?? '';
    this.bank = data.bank ?? { en_name: '', ar_name: '', code: '', swift_code: '' };
  }

  static fromJson(data: any): InvestorBankDetails {
    return new InvestorBankDetails({
      ...data,
    });
  }

  get bankName() {
    return this.bank.en_name || '';
  }
}

export default InvestorBankDetails;
